import { config } from "../config.js";
import { mission } from "./missions.js";
import { nextRandom, randomRange } from "./rng.js";
import { fieldOf } from "./scale.js";

// ステージごとの「仕掛け1つ」(2026-10-30 段階1。値は config.stages の gimmick と config.gimmicks。敵の出る順は 2026-10-31 から config.enemies.roster)。
// どのステージかは前進した秒(world.progress)で決まる。停止戦の間は仕掛けを新しく出さない。
// 仕掛けの状態は world.hazards(JSON にできる素のデータ)に持つ。乱数は rng.js だけを使う。
// スケール感(src/sim/scale.js): 柵・対空砲の太さ(w)と速さは、出したときの倍率で大きくする。

export function stageAt(progress) {
  const list = mission().stages;
  let s = list[0];
  for (const st of list) if (progress >= st.from) s = st;
  return s;
}

// h: world.js の部品 { spawnEnemy, hurtPlayer }
export function stepGimmicks(world, dt, h) {
  const g = config.gimmicks;
  const p = world.player;
  const f = fieldOf(world);
  const s = world.scale;
  const id = stageAt(world.progress).gimmick;

  // 新しく出す
  if (!world.hold && id && g[id].every) {
    world.gimmickAcc += dt;
    if (world.gimmickAcc >= g[id].every) {
      world.gimmickAcc = 0;
      if (id === "satellite" || id === "rock") {
        h.spawnEnemy(world, id, randomRange(world, -f.halfWidth, f.halfWidth), randomRange(world, -f.halfHeight, f.halfHeight), f.spawnFrontZ);
      } else if (id === "fence") {
        // 横の柵(y が決まった棒)か、縦の柵(x が決まった棒)。自機の近くを通る
        const axis = nextRandom(world) < 0.5 ? "x" : "y";
        const lim = axis === "x" ? f.halfWidth : f.halfHeight;
        const pos = Math.max(-lim, Math.min(lim, (axis === "x" ? p.x : p.y) + randomRange(world, -8, 8) * s));
        world.hazards.push({ k: "fence", axis, pos, z: f.spawnFrontZ, v: g.fence.speed * s, w: g.fence.halfWidth * s });
      } else if (id === "flak") {
        // 地上からの対空砲: 自機のいる x を狙う。予告のあと、縦の光の柱になる
        world.hazards.push({ k: "flak", x: p.x + randomRange(world, -4, 4) * s, t: 0, hit: 0, w: g.flak.halfWidth * s });
      }
    }
  }

  // 動かす・当てる
  for (const hz of world.hazards) {
    if (hz.k === "fence") {
      const before = hz.z;
      hz.z += hz.v * dt;
      if (before < 0 && hz.z >= 0) {
        const d = hz.axis === "x" ? p.x - hz.pos : p.y - hz.pos;
        if (Math.abs(d) < hz.w + config.player.radius) h.hurtPlayer(world, g.fence.damage, { x: hz.axis === "x" ? hz.pos : p.x, y: hz.axis === "y" ? hz.pos : p.y, z: 0 });
      }
      if (hz.z > f.despawnBehindZ) hz.done = 1;
    } else if (hz.k === "flak") {
      hz.t += dt;
      const fire = hz.t >= g.flak.warnSeconds;
      if (fire && !hz.hit && Math.abs(p.x - hz.x) < hz.w + config.player.radius) {
        hz.hit = 1;
        h.hurtPlayer(world, g.flak.damage, { x: hz.x, y: -f.halfHeight * 2, z: 0 });
      }
      if (fire && hz.t - dt < g.flak.warnSeconds) world.events.push({ k: "flak", x: hz.x });
      if (hz.t >= g.flak.warnSeconds + g.flak.fireSeconds) hz.done = 1;
    }
  }
  world.hazards = world.hazards.filter((hz) => !hz.done);

  // 熱の帯: 動ける範囲の端にいると、少しずつ SHIELD が減る(真ん中へ寄せる)
  if (id === "heat" && !world.hold) {
    const hot = Math.abs(p.x) > f.halfWidth * g.heat.edge || Math.abs(p.y) > f.halfHeight * g.heat.edge;
    if (hot) {
      const dmg = g.heat.damagePerSecond * dt;
      p.shield -= dmg;
      world.stats.damageTaken += dmg;
      if (world.tick % 15 === 0) world.events.push({ k: "heat" });
    }
  }
}
